import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import Spinner from 'static/script/libs/spin';

function KlarnaSignup() {

    this.defaultAttrs({
        bankAccount: '[data-klarna-signup-bankaccount]',
        clearingNumber: '[data-klarna-signup-clearingnumber]',
        personalNumber: '[data-klarna-signup-personalnumber]',
        street: '[data-klarna-signup-street]',
        zipCode: '[data-klarna-signup-zip-code]',
        city: '[data-klarna-signup-city]',
        submitButton: '[data-klarna-signup-submit-button]',
        submitButtonText: '[data-klarna-signup-submit-button-text]',
        cancelButton: '[data-klarna-signup-cancel-button]',
        eulaCheckbox: '[data-klarna-signup-eula]',
        updateAdressCheckbox: '[data-klarna-signup-update-adress-checkbox]',
        input: 'input',
        bankAccountCharsValidationMessage: '[data-klarna-signup-bankaccount-chars-validation-message]',
        bankAccountRequiredValidationMessage: '[data-klarna-signup-bankaccount-required-validation-message]',
        clearingNumberCharsValidationMessage: '[data-klarna-signup-clearingnumber-chars-validation-message]',
        clearingNumberRequiredValidationMessage: '[data-klarna-signup-clearingnumber-required-validation-message]',
        eulaRequiredValidationMessage: '[data-klarna-signup-eula-validation-message]',
        bankAccountLabel: '[data-klarna-signup-bankaccount-label]',
        clearingNumberLabel: '[data-klarna-signup-clearingnumber-label]',
        serverSideErrorBankAccount: '[data-klarna-signup-server-side-error-bankaccount]',
        serverSideErrorAddress: '[data-klarna-signup-server-side-error-address]',
        serverSideErrorUnhandled: '[data-klarna-signup-server-side-error-unhandled]',
        readAboutKlarnaLink: '[data-read-about-klarna]',
        modalIframe: '#klarna-signup-modal-iframe'
    });

    this._onSubmitClick = function () {

        this.submitClicked = true;
        this._hideServerSideError();

        let validationResult = this._validateInputs();
        if (!validationResult.isFormValid) {
            this._scrollToInvalidInput(validationResult);
            return;
        }

        if (this.isSubmitting) {
            return;
        }

        let payload = {
            bankAccount: this.select('bankAccount').val(),
            clearingNumber: this.select('clearingNumber').val(),
            street: this.select('street').val(),
            zipCode: this.select('zipCode').val(),
            city: this.select('city').val(),
            updateAdress: this.select('updateAdressCheckbox').prop('checked')
        };

        this.isSubmitting = true;

        this.trigger(document, 'ui:klarna-signup:submit', payload);

        this._delaySubmitSpinner();
    };

    this._onReadAboutKlarnaClick = function (evt) {
        evt.preventDefault();
        let viewportHeight = $(window).height() * 0.8;
        let payload = {
            content: '<iframe src="http://info.tradera.com/modal/klarnasignup/" class="klarna-signup-modal-iframe" style="height:' + viewportHeight + 'px;" frameborder="0" marginwidth="0" marginheight="0"></iframe>',
            cssClass: 'klarna-signup-modal'
        };
        this.trigger(document, 'ui:modal:open', payload);
    };

    this._scrollToInvalidInput = function (validationResult) {
        // Start with the top element and work your way down
        if (!validationResult.isClearingNumberValid) {
            this._scrollToElement('clearingNumberLabel');
        } else if (!validationResult.isBankAccountValid) {
            this._scrollToElement('bankAccountLabel');
        }
    };

    this._isElementInViewport = function (element) {
        let rect = element.getBoundingClientRect();
        return (rect.top >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
    };

    this._scrollToElement = function (name) {
        let element = this.select(name);
        if (this._isElementInViewport(element[0])) {
            return;
        }
        $('html, body').animate({ scrollTop: element.offset().top }, 500);
    };

    this._delaySubmitSpinner = function () {
        this.timeout = setTimeout(function () {
            this._enableSubmitSpinner();
        }.bind(this), 100);
    };

    this._enableSubmitSpinner = function () {
        this._initSpinner();
        this.spinner.spin();
        let buttonHeight = this.select('submitButton').height();
        this.select('submitButtonText').hide();
        this.select('submitButton').append(this.spinner.el);
        this.select('submitButton').height(buttonHeight);
    };

    this._disableSubmitSpinner = function () {
        if (this.spinner) {
            this.spinner.stop();
        }
        this.select('submitButtonText').show();
    };

    this._showServerSideError = function (error) {
        if (error === 'BankAccount') {
            this.select('serverSideErrorBankAccount').show();
        } else if (error === 'Address') {
            this.select('serverSideErrorAddress').show();
        } else {
            this._showUnhandledServerSideError();
        }
    };

    this._showUnhandledServerSideError = function () {
        this.select('serverSideErrorUnhandled').show();
    };

    this._hideServerSideError = function () {
        this.select('serverSideErrorBankAccount').hide();
        this.select('serverSideErrorAddress').hide();
        this.select('serverSideErrorUnhandled').hide();
    };

    this._onCancelClick = function () {

    };

    this._afterSubmit = function (evt, data) {
        this.isSubmitting = false;
        if (data.ok) {
            this.trigger(document, 'ui:navigate', { href: '/my/klarna-signup/success' });
        }
        else if (data.userCanResolveError) {
            this._showServerSideError(data.error);
            this._disableSubmitSpinner();
        }
        else if (data.redirectToCs) {
            this.trigger(document, 'ui:navigate', { href: '/my/klarna-signup/contact-customer-support' });
        }
        else if (data.rejected) {
            this.trigger(document, 'ui:navigate', { href: '/my/klarna-signup/rejected' });
        }
        else {
            this._showUnhandledServerSideError();
            this._disableSubmitSpinner();
        }
    };

    this._onSubmitError = function () {
        this.isSubmitting = false;
        this._disableSubmitSpinner();
    };

    this._initSpinner = function () {
        if (this.spinner) {
            return;
        }
        let options = {
            lines: 9,
            length: 5,
            width: 4,
            radius: 5,
            corners: 1,
            rotate: 0,
            direction: 1,
            color: '#fff',
            position: 'relative'
        };
        this.spinner = new Spinner(options);
    };

    this._onInputChange = function () {
        this._validateInputs();
    };

    this._validateFieldRequired = function (name) {
        let val = this.select(name).val();
        return val.trim() !== '';
    };

    this._validateBankAccountChars = function (name) {
        let val = this.select(name).val();
        let hasDigitsOnly = /^\s*\d+[-\d\s]*$/.test(val);
        return hasDigitsOnly;
    };

    this._validateBankAccount = function () {
        this._visible('bankAccountCharsValidationMessage', false);
        this._visible('bankAccountRequiredValidationMessage', false);

        if (!this._validateFieldRequired('bankAccount')) {
            if (this.submitClicked) {
                this._visible('bankAccountRequiredValidationMessage', true);
            }
            return false;
        }

        if (!this._validateBankAccountChars('bankAccount')) {
            this._visible('bankAccountCharsValidationMessage', true);
            return false;
        }

        return true;
    };

    this._validateClearingNumber = function () {
        this._visible('clearingNumberCharsValidationMessage', false);
        this._visible('clearingNumberRequiredValidationMessage', false);

        if (!this._validateFieldRequired('clearingNumber')) {
            if (this.submitClicked) {
                this._visible('clearingNumberRequiredValidationMessage', true);
            }
            return false;
        }

        if (!this._validateBankAccountChars('clearingNumber')) {
            this._visible('clearingNumberCharsValidationMessage', true);
            return false;
        }

        return true;
    };

    this._validateEula = function () {
        this._visible('eulaRequiredValidationMessage', false);

        if (!this.select('eulaCheckbox').prop('checked')) {
            if (this.submitClicked) {
                this._visible('eulaRequiredValidationMessage', true);
            }
            return false;
        }

        return true;
    };

    this._validateInputs = function () {
        let isBankAccountValid = this._validateBankAccount();
        let isClearingNumberValid = this._validateClearingNumber();
        let isEulaValid = this._validateEula();
        return {
            isBankAccountValid: isBankAccountValid,
            isClearingNumberValid: isClearingNumberValid,
            isEulaValid: isEulaValid,
            isFormValid: isBankAccountValid && isClearingNumberValid && isEulaValid
        };
    };

    this._visible = function (selector, visible) {
        if (visible) {
            this.select(selector).show();
        } else {
            this.select(selector).hide();
        }
    };

    this.after('initialize', function () {
        this.on('click', {
            submitButton: this._onSubmitClick,
            cancelButton: this._onCancelClick,
            readAboutKlarnaLink: this._onReadAboutKlarnaClick
        });

        this.on('change', { input: this._onInputChange });
        this.on('keyup', { input: this._onInputChange });

        this.on(document, 'data:klarna-signup:after-submit', this._afterSubmit);
        this.on(document, 'data:klarna-signup:on-submit-error', this._onSubmitError);
    });
}

module.exports = defineComponent.component(KlarnaSignup);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/klarna-signup-ui.js